import { useEffect, useState, useRef } from 'react';

// mode values:- slideIn, slideOut, slideInPDP, bouncePDP, null;
// slideIn mode marks popup to enter the screen with animation.
// slideInPDP mode marks popup to enter the screen with animation in PDP.
// bouncePDP mode marks popup to bounce up if FDL button is in display in PDP.
// slideOut mode marks popup to leave the screen with animation.
// changedToVisible is marked true when modal slides In viewport.
export const useSlideIn = (threshold, target) => {
  const [mode, setMode] = useState(null);
  const prevMode = useRef(null);

  const handleScrollDefault = () => {
    const slideNow = window.scrollY > document.body.scrollHeight * threshold;
    if (slideNow) {
      setMode(oldState => (oldState !== 'slideOut' ? 'slideIn' : oldState));
    }
  };

  const handleScrollPDP = () => {
    const slideNow = window.scrollY > document.body.scrollHeight * threshold;
    if (slideNow) {
      if (document.querySelector('.fdl-button')) {
        setMode('bouncePDP');
      } else {
        setMode(oldState =>
          oldState !== 'slideOut' ? 'slideInPDP' : oldState,
        );
      }
    }
  };

  const handleScroll = () =>
    target === 'PDP' ? handleScrollPDP() : handleScrollDefault();

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    prevMode.current = mode;
  });

  const changedToVisible =
    !!prevMode && ['slideIn', 'slideInPDP'].includes(mode);
  return [mode, changedToVisible, setMode];
};
